import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export const useMediaQueryHook = () => {
  const theme = useTheme();

  const isSmallScreen = useMediaQuery(theme.breakpoints.down(500));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down(780));
  const isLargeScreen = useMediaQuery(theme.breakpoints.down(1200));

  return {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    theme,
  };
};
